import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[appHtmlValidation]',
    standalone: false
})
export class HtmlValidationDirective {
  @Output() htmlDetected = new EventEmitter<boolean>();

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const inputContent = inputElement.value;

    const containsHtml = /<[a-z][\s\S]*>/i.test(inputContent);

    this.htmlDetected.emit(containsHtml);

    if (containsHtml) {
      inputElement.classList.add('html-detected');
    } else {
      inputElement.classList.remove('html-detected');
    }
  }
}
